import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authManager } from '../services/authManager';
import TrialFrame from '../components/TrialFrame';

export default function TrialStartPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    let cancelled = false;
    authManager.getTrialStatus().then(async ({ trial }) => {
      if (trial?.status !== 'pending') {
        await authManager.refreshToken();
        if (!cancelled) navigate(trial?.status === 'expired' ? '/trial/status' : '/app', { replace: true });
      } else if (!cancelled) setReady(true);
    }).catch(err => { if (!cancelled) setError(err.message); });
    return () => { cancelled = true; };
  }, [navigate]);
  const submit = async event => {
    event.preventDefault(); setError('');
    if (password !== confirm) { setError('Las contraseñas no coinciden.'); return; }
    setBusy(true);
    try { await authManager.activateTrial(password); navigate('/app', { replace: true }); }
    catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <TrialFrame title="Tu prueba comienza contigo" subtitle="Elige una contraseña personal. Desde este momento tendrás cinco días completos para explorar Numerathum.">
    <form onSubmit={submit} className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl space-y-5">
      <p className="text-sm text-gray-600">Tu usuario: <strong className="break-all">{authManager.getCurrentUser()?.email}</strong></p>
      <div><label htmlFor="trial-password" className="block text-sm font-medium mb-2">Nueva contraseña</label><input id="trial-password" type="password" autoComplete="new-password" required minLength={8} maxLength={64} value={password} onChange={e => setPassword(e.target.value)} className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-morado" /><p className="text-xs text-gray-500 mt-2">Al menos 8 caracteres. Puedes usar una frase fácil de recordar.</p></div>
      <div><label htmlFor="trial-confirm" className="block text-sm font-medium mb-2">Repite tu contraseña</label><input id="trial-confirm" type="password" autoComplete="new-password" required value={confirm} onChange={e => setConfirm(e.target.value)} className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-morado" /></div>
      {error && <p role="alert" className="text-red-700 bg-red-50 rounded-xl p-3 text-sm">{error}</p>}
      {error && !ready && <button type="button" onClick={() => window.location.reload()} className="text-morado underline">Reintentar</button>}
      <button disabled={busy || !ready} className="w-full bg-morado rounded-xl py-3 text-white font-semibold disabled:opacity-60">{busy ? 'Activando tu prueba…' : 'Activar mis 5 días gratis'}</button>
      <p className="text-xs text-gray-500 text-center">Después completarás tu perfil para personalizar tu experiencia.</p>
      <button type="button" onClick={() => { authManager.logout(); navigate('/login'); }} className="block mx-auto text-sm text-morado underline">Usar otra cuenta</button>
    </form>
  </TrialFrame>;
}
